import React, { useState } from "react";
import x from "../../assets/Group 6.svg";
import { useMusic } from "./music";

const Settings = ({ open, onClose, onPlaySound, onNavigate }) => {
  const [soundOn, setSoundOn] = useState(true);

  const { muted, toggleMute } = useMusic();

  if (!open) return null;

  return (
    <div className="settingsoverlay">

      <div className="settingsbox">

        <div className="closex" onClick={onClose}>
          <img className="x" src={x} alt="close" />
        </div>

        <h2 className="settext">SETTINGS</h2>

        <div className="settingitem">
          <label>Sound</label>
          <div
            className={`mutetoggle ${soundOn ? "active" : ""}`}
            onClick={() => setSoundOn(!soundOn)}
          />
        </div>

        <div className="settingitem">
          <label>Music</label>
          <div
            className={`mutetoggle ${!muted ? "active" : ""}`}
            onClick={toggleMute}
          />
        </div>

        <div className="settingitem">
          <label>Brightness</label>
          <input type="range" />
        </div>

        <button
          className="exitbtn"
          onClick={() => {
            onPlaySound();
            onNavigate("/");
          }}
        >
          EXIT TO MAIN MENU
        </button>

      </div>

    </div>
  );
};

export default Settings;